<template>
  <b-modal
    id="modalDeviceInfo"
    v-model="localIsActive"
    centered
    no-close-on-esc
    no-close-on-backdrop
    size="lg"
    header-bg-variant="dark"
    header-text-variant="light"
    @hidden="closeModal"
  >
    <template #modal-title> {{ $t("hanwha_camera.device_information") }} {{ hanwhaCamera.name }}</template>
    <div class="text-danger" v-if="showNoDataMessage && !isDeviceInfoLoading">
      {{ $t('grid.widgets.alarms.table.no_data') }}
    </div>
    <b-row v-if="deviceInfo">
      <b-col
        cols="4"
        v-for="(info, index) in deviceInfo"
        md="4"
        :key="index">
        <b-form-group
          class="text-capitalize"
          :label="index"
          :label-for="index">
          <b-form-input
            :id="index"
            v-model="deviceInfo[index]"
            trim
            :placeholder="index"
            readonly
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="!deviceInfo && isDeviceInfoLoading">
      <b-col
        cols="4"
        v-for="(loading, index) in 3"
        md="4"
        :key="index">
        <SkeletonLoading :width="234" :height="37"/>
      </b-col>
    </b-row>


  </b-modal>
</template>

<script>
import { BModal, BSpinner } from "bootstrap-vue";
import { computed, ref } from "@vue/composition-api";
import vSelect from "vue-select";
import { useDeviceInfo } from "./useDeviceInfo";
import SkeletonLoading from "@/components/SkeletonLoading.vue";

export default {
  components: {
    BModal,
    BSpinner,
    vSelect,
    SkeletonLoading
  },
  props: {
    hanwhaCamera: { type: Object, required: true },
    isModalInfoActive: { type: Boolean, required: true },
  },
  setup(props, { emit }) {
    const isModalActive = ref(false);
    const { getDeviceInfo, deviceInfo, isDeviceInfoLoading, showNoDataMessage } = useDeviceInfo(props.hanwhaCamera)

    const localIsActive = computed({
      get() {
        return props.isModalInfoActive;
      },
      set(value) {
        emit("update:isActive", value);
      },
    });

    const closeModal = () => {
      emit('close-modal');
    };
    getDeviceInfo()

    return {
      isModalActive,
      localIsActive,
      showNoDataMessage,
      deviceInfo,
      isDeviceInfoLoading,
      closeModal,
    };
  },
};
</script>
